<template>
  <div class="task-page common-bg">
    <!-- 顶部活跃度 + 宝箱进度条 -->
    <div class="activity-box">
      <div class="activity-header">
        <div class="activity-left">
          <span class="lightning-icon-wrap">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
              <circle cx="12" cy="12" r="10" stroke="#3CC82F" stroke-width="2" fill="none"/>
              <path d="M13 4L6 13H11L10 20L18 11H13L14 4Z" fill="#3CC82F"/>
            </svg>
          </span>
          <span class="activity-value">0</span>
        </div>
        <div class="activity-detail" @click="showDetail = true">详情</div>
      </div>

      <!-- 宝箱进度条 -->
      <div class="treasure-progress">
        <div class="treasure-item">
          <div class="treasure-icon-wrap">
            <img src="/static/image/img_rwbx_0.avif" class="treasure-icon" />
            <span class="treasure-num">{{ treasureList[0].num }}</span>
          </div>
          <div class="treasure-label">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none">
              <circle cx="12" cy="12" r="10" stroke="#888" stroke-width="2" fill="none"/>
              <path d="M13 4L6 13H11L10 20L18 11H13L14 4Z" fill="#888"/>
            </svg>
            -{{ treasureList[0].value }}
          </div>
        </div>
        <div class="treasure-arrow">
          <svg viewBox="0 0 60 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="0" y1="6" x2="45" y2="6" stroke="#555" stroke-width="1.5"/>
            <path d="M45 2L55 6L45 10" stroke="#555" stroke-width="1.5" fill="none"/>
          </svg>
        </div>
        <div class="treasure-item">
          <div class="treasure-icon-wrap">
            <img src="/static/image/img_rwbx_0.avif" class="treasure-icon" />
            <span class="treasure-num">{{ treasureList[1].num }}</span>
          </div>
          <div class="treasure-label">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none">
              <circle cx="12" cy="12" r="10" stroke="#888" stroke-width="2" fill="none"/>
              <path d="M13 4L6 13H11L10 20L18 11H13L14 4Z" fill="#888"/>
            </svg>
            -{{ treasureList[1].value }}
          </div>
        </div>
        <div class="treasure-arrow">
          <svg viewBox="0 0 60 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="0" y1="6" x2="45" y2="6" stroke="#555" stroke-width="1.5"/>
            <path d="M45 2L55 6L45 10" stroke="#555" stroke-width="1.5" fill="none"/>
          </svg>
        </div>
        <div class="treasure-item">
          <div class="treasure-icon-wrap">
            <img src="/static/image/img_rwbx_0.avif" class="treasure-icon" />
            <span class="treasure-num">{{ treasureList[2].num }}</span>
          </div>
          <div class="treasure-label">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none">
              <circle cx="12" cy="12" r="10" stroke="#888" stroke-width="2" fill="none"/>
              <path d="M13 4L6 13H11L10 20L18 11H13L14 4Z" fill="#888"/>
            </svg>
            -{{ treasureList[2].value }}
          </div>
        </div>
        <div class="treasure-arrow">
          <svg viewBox="0 0 60 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="0" y1="6" x2="45" y2="6" stroke="#555" stroke-width="1.5"/>
            <path d="M45 2L55 6L45 10" stroke="#555" stroke-width="1.5" fill="none"/>
          </svg>
        </div>
        <div class="treasure-item">
          <div class="treasure-icon-wrap">
            <img src="/static/image/img_rwbx_0.avif" class="treasure-icon" />
            <span class="treasure-num">{{ treasureList[3].num }}</span>
          </div>
          <div class="treasure-label">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none">
              <circle cx="12" cy="12" r="10" stroke="#888" stroke-width="2" fill="none"/>
              <path d="M13 4L6 13H11L10 20L18 11H13L14 4Z" fill="#888"/>
            </svg>
            -{{ treasureList[3].value }}
          </div>
        </div>
      </div>
    </div>

    <!-- 选项卡 -->
    <div class="task-tabs">
      <div class="task-tab" v-for="(tab, index) in taskTabs" :key="index" :class="{ active: activeTab === index }" @click="activeTab = index">
        {{ tab }}
      </div>
      <div class="task-refresh" @click="handleRefresh">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="14" height="14">
          <path d="M1 4V10H7" stroke="#DFB372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.51 15C4.14 17.07 5.47 18.83 7.27 20.01C9.07 21.19 11.23 21.72 13.37 21.51C15.51 21.3 17.52 20.36 19.07 18.84C20.62 17.32 21.62 15.31 21.93 13.16C22.24 11.01 21.84 8.82 20.79 6.93C19.74 5.04 18.1 3.56 16.12 2.71C14.14 1.86 11.93 1.69 9.85 2.23C7.77 2.77 5.93 3.99 4.62 5.71" stroke="#DFB372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        刷新
      </div>
    </div>

    <!-- 新人福利头部 -->
    <div class="newbie-header" v-if="activeTab === 0">
      <div class="newbie-left">
        <img src="/static/image/img_rw_xr.avif" class="newbie-icon" />
        <span class="newbie-badge">NEW</span>
      </div>
      <div class="newbie-right" @click="goToRecord">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
          <rect x="5" y="3" width="14" height="18" rx="2" stroke="#DFB372" stroke-width="1.5"/>
          <line x1="9" y1="7" x2="15" y2="7" stroke="#DFB372" stroke-width="1.5"/>
          <line x1="9" y1="11" x2="15" y2="11" stroke="#DFB372" stroke-width="1.5"/>
          <line x1="9" y1="15" x2="13" y2="15" stroke="#DFB372" stroke-width="1.5"/>
        </svg>
      </div>
    </div>

    <!-- 每日任务头部 -->
    <div class="daily-header" v-if="activeTab === 1">
      <div class="daily-left">
        <img src="/static/image/img_rw_mrrw.avif" class="daily-icon" />
        <div class="daily-countdown">
          <span class="countdown-num">{{ countdownHours }}</span>
          <span class="countdown-sep">:</span>
          <span class="countdown-num">{{ countdownMinutes }}</span>
          <span class="countdown-sep">:</span>
          <span class="countdown-num">{{ countdownSeconds }}</span>
          <span class="countdown-text">后重置</span>
        </div>
      </div>
      <div class="daily-right" @click="goToRecord">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
          <rect x="5" y="3" width="14" height="18" rx="2" stroke="#DFB372" stroke-width="1.5"/>
          <line x1="9" y1="7" x2="15" y2="7" stroke="#DFB372" stroke-width="1.5"/>
          <line x1="9" y1="11" x2="15" y2="11" stroke="#DFB372" stroke-width="1.5"/>
          <line x1="9" y1="15" x2="13" y2="15" stroke="#DFB372" stroke-width="1.5"/>
        </svg>
      </div>
    </div>

    <!-- 任务列表 -->
    <div class="task-list" v-if="taskList.length > 0">
      <div class="task-item" v-for="(item, index) in taskList" :key="index">
        <div class="task-name-bar" :class="{ 'no-icon': !item.iconType }">
          <div class="task-icon-wrap" v-if="item.iconType">
            <!-- 首次下载 -->
            <svg v-if="item.iconType === 'download'" viewBox="0 0 24 24" width="20" height="20" fill="none">
              <path d="M12 3V15M12 15L7 10M12 15L17 10" stroke="#DFB372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4 17V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V17" stroke="#DFB372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <!-- 手机验证 -->
            <svg v-else-if="item.iconType === 'phone'" viewBox="0 0 24 24" width="20" height="20" fill="none">
              <rect x="5" y="2" width="14" height="20" rx="2" stroke="#DFB372" stroke-width="2"/>
              <line x1="12" y1="18" x2="12" y2="18.01" stroke="#DFB372" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <!-- 银行卡 -->
            <svg v-else-if="item.iconType === 'bankcard'" viewBox="0 0 24 24" width="20" height="20" fill="none">
              <rect x="2" y="5" width="20" height="14" rx="2" stroke="#DFB372" stroke-width="2"/>
              <line x1="2" y1="10" x2="22" y2="10" stroke="#DFB372" stroke-width="2"/>
              <line x1="6" y1="15" x2="10" y2="15" stroke="#DFB372" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <!-- 提现 -->
            <svg v-else-if="item.iconType === 'withdraw'" viewBox="0 0 24 24" width="20" height="20" fill="none">
              <path d="M12 15V3M12 3L7 8M12 3L17 8" stroke="#DFB372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4 17V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V17" stroke="#DFB372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <!-- 数字货币 -->
            <svg v-else-if="item.iconType === 'crypto'" viewBox="0 0 24 24" width="20" height="20" fill="none">
              <circle cx="12" cy="12" r="9" stroke="#DFB372" stroke-width="2"/>
              <path d="M10 8H14M10 12H14M10 16H14" stroke="#DFB372" stroke-width="1.5" stroke-linecap="round"/>
              <line x1="12" y1="6" x2="12" y2="18" stroke="#DFB372" stroke-width="1.5"/>
            </svg>
            <!-- 密保 -->
            <svg v-else-if="item.iconType === 'security'" viewBox="0 0 24 24" width="20" height="20" fill="none">
              <rect x="3" y="11" width="18" height="11" rx="2" stroke="#DFB372" stroke-width="2"/>
              <path d="M7 11V7C7 4.24 9.24 2 12 2C14.76 2 17 4.24 17 7V11" stroke="#DFB372" stroke-width="2"/>
              <circle cx="12" cy="16" r="1" fill="#DFB372"/>
            </svg>
            <!-- 默认 -->
            <svg v-else viewBox="0 0 24 24" width="20" height="20" fill="none">
              <circle cx="12" cy="12" r="9" stroke="#DFB372" stroke-width="2"/>
            </svg>

          </div>
          <span class="task-name">{{ item.name }}</span>
          <span class="task-limit" v-if="item.limit">{{ item.limit }}</span>
        </div>
        <div class="task-body" :class="{ 'daily-layout': activeTab === 1 }">
          <div class="reward-coin" v-if="item.coinAmount">
            <div class="coin-icon-circle">
              <span class="icon-coin">¥</span>
            </div>
            <span class="reward-amount">{{ item.coinAmount }}</span>
          </div>
          <div class="reward-lightning">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="#3CC82F" stroke-width="2" fill="none"/>
              <path d="M13 4L6 13H11L10 20L18 11H13L14 4Z" fill="#3CC82F"/>
            </svg>
            <span class="lightning-amount">{{ item.lightning }}</span>
          </div>
          <div class="task-progress" v-if="item.target > 1">
            <div class="progress-bar">
              <div class="progress-fill" :style="{ width: item.progressPercent + '%' }"></div>
            </div>
            <span class="progress-text">{{ item.current }}/{{ item.target }}</span>
          </div>
          <div class="task-btn" @click="handleTaskAction(item)">
            {{ item.btnText }}
          </div>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <div class="task-empty" v-else>
      <div class="empty-icon-wrap">
        <img src="/static/image/img_none_sj.avif" class="empty-icon" alt="" />
      </div>
      <div class="empty-text">暂无内容</div>
    </div>

    <!-- 规则描述 -->
    <div class="task-rules" v-if="taskRules.length > 0">
      <div class="rule-item" v-for="(rule, index) in taskRules" :key="index" :class="{ 'rule-title': rule === '条款及细则' }">
        {{ rule }}
      </div>
    </div>

    <!-- 详情弹窗 -->
    <div class="detail-overlay" v-if="showDetail" @click="showDetail = false"></div>
    <div class="detail-popup" v-if="showDetail">
      <div class="detail-header">活跃度记录</div>
      <div class="detail-tabs">
        <div class="detail-tab" v-for="(tab, index) in detailTabs" :key="index" :class="{ active: activeDetailTab === index }" @click="activeDetailTab = index">
          {{ tab }}
        </div>
      </div>
      <div class="detail-filter-bar">
        <div class="detail-filter-item" @click="showDetailTime = !showDetailTime">
          <span>{{ detailTimeOptions[detailTimeIndex].text }}</span>
          <van-icon name="arrow-down" size="10" />
          <div class="detail-filter-dropdown" v-show="showDetailTime">
            <div v-for="(opt, idx) in detailTimeOptions" :key="idx"
                 class="detail-filter-option" :class="{ active: detailTimeIndex === idx }"
                 @click="detailTimeIndex = idx; showDetailTime = false;">{{ opt.text }}</div>
          </div>
        </div>
        <div class="detail-activity">
          累计活跃度
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" fill="#3CC82F" stroke="#3CC82F" stroke-width="1.5" stroke-linejoin="round"/>
          </svg>
          <span>0</span>
        </div>
      </div>
      <div class="detail-empty">
        <div class="empty-icon-wrap">
          <img src="/static/image/img_none_sj.avif" class="empty-icon" alt="" />
        </div>
        <div class="empty-text">今日暂无记录，<span class="empty-link">可查看更多</span></div>
      </div>
      <div class="detail-close" @click="showDetail = false">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="28" height="28">
          <circle cx="12" cy="12" r="10" stroke="#fff" stroke-width="2"/>
          <line x1="8" y1="8" x2="16" y2="16" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
          <line x1="16" y1="8" x2="8" y2="16" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'taskComponents',
  data() {
    return {
      showDetail: false,
      activeTab: 0,
      activeDetailTab: 0,
      detailTimeIndex: 0,
      showDetailTime: false,
      taskTabs: ['新人福利', '每日任务', '每周任务'],
      detailTabs: ['已获得', '已使用', '已过期'],
      detailTimeOptions: [
        { text: '今日', value: 0 },
        { text: '昨日', value: 1 },
        { text: '本周', value: 2 },
        { text: '本月', value: 3 },
        { text: '全部', value: 4 },
      ],
      treasureList: [
        { num: 1, value: 15 },
        { num: 2, value: 35 },
        { num: 3, value: 65 },
        { num: 4, value: 100 },
      ],
      taskList: [],
      taskRules: [],
      countdownHours: '00',
      countdownMinutes: '00',
      countdownSeconds: '00',
      countdownTimer: null,
    };
  },
  created() {
    this.loadTaskList();
    this.startCountdown();
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    loadTaskList() {
      let that = this;
      if (that.activeTab === 0) {
        that.taskList = [
          { name: '首次下载安装并登录APP', iconType: 'download', limit: '', coinAmount: '', lightning: 3, current: 0, target: 1, progressPercent: 0, btnText: '前往' },
          { name: '手机短信验证', iconType: 'phone', limit: '', coinAmount: '', lightning: 3, current: 0, target: 1, progressPercent: 0, btnText: '前往' },
          { name: '首次绑定银行卡', iconType: 'bankcard', limit: '', coinAmount: '', lightning: 2, current: 0, target: 1, progressPercent: 0, btnText: '前往' },
          { name: '首次提现', iconType: 'withdraw', limit: '', coinAmount: '', lightning: 2, current: 0, target: 1, progressPercent: 0, btnText: '前往' },
          { name: '首次绑定数字货币', iconType: 'crypto', limit: '', coinAmount: '', lightning: 1, current: 0, target: 1, progressPercent: 0, btnText: '前往' },
          { name: '设置密保', iconType: 'security', limit: '', coinAmount: '', lightning: 1, current: 0, target: 1, progressPercent: 0, btnText: '前往' },
        ];
        that.taskRules = [
          '1. 适用对象：首次注册平台的新用户。',
          '2. 任务期限：自注册成功之日起，1天内有效，逾期任务奖励将失效。',
          '3. 奖励发放：完成任务后，需在指定时间内手动领取，仅限PC、Android H5、iOS H5、Android_APP、iOS_APP',
          '4. 奖励有效期：所有类型的奖励均有有效期，请在规定时间内领取或者使用，逾期作废',
          '5. 投注说明：赠送的奖金需1倍流水（即稽核或有效投注）才能提现，投注不限游戏平台',
          '条款及细则',
          '1.每位玩家只能使用一个账号，不可使用多账号，开设多个或欺诈账户的玩家将被取消活动资格，剩余金额可能会被没收且账户将被冻结',
          '2.本站保留自行决定修改、变更、终止、取消、拒绝此优惠活动的权利',
          '3.参与活动的玩家必须接受并遵守本活动的条款，并且申请此优惠，即代表同意该活动规则及对应条款',
          '4.为避免文字理解歧义，本站保留本活动最终解释权',
        ];
      } else if (that.activeTab === 1) {
        that.taskList = [
          { name: '累计投注≥500', icon: '/static/image/img_rw_xr.avif', limit: '仅限：电子-PG', coinAmount: '2.00', lightning: 5, current: 0, target: 500, progressPercent: 0, btnText: '前往' },
          { name: '累计投注≥500', icon: '/static/image/img_rw_xr.avif', limit: '仅限：电子-BBIN', coinAmount: '2.00', lightning: 5, current: 0, target: 500, progressPercent: 0, btnText: '前往' },
          { name: '累计投注≥500', icon: '/static/image/img_rw_xr.avif', limit: '仅限：电子-CQ9', coinAmount: '2.00', lightning: 5, current: 0, target: 500, progressPercent: 0, btnText: '前往' },
          { name: '累计投注≥500', icon: '/static/image/img_rw_xr.avif', limit: '仅限：电子-MG', coinAmount: '2.00', lightning: 5, current: 0, target: 500, progressPercent: 0, btnText: '前往' },
          { name: '累计投注≥500', icon: '/static/image/img_rw_xr.avif', limit: '仅限：捕鱼-JDB(财神捕鱼)', coinAmount: '2.00', lightning: 5, current: 0, target: 500, progressPercent: 0, btnText: '前往' },
          { name: '累计投注≥500', icon: '/static/image/img_rw_xr.avif', limit: '仅限：棋牌-开元', coinAmount: '2.00', lightning: 5, current: 0, target: 500, progressPercent: 0, btnText: '前往' },
          { name: '累计投注≥5,000', icon: '/static/image/img_rw_xr.avif', limit: '仅限：电子-全部游戏', coinAmount: '5.00', lightning: 5, current: 0, target: 5000, progressPercent: 0, btnText: '前往' },
          { name: '累计投注≥10,000', icon: '/static/image/img_rw_xr.avif', limit: '仅限：电子-全部游戏', coinAmount: '10.00', lightning: 10, current: 0, target: 10000, progressPercent: 0, btnText: '前往' },
          { name: '累计投注≥50,000', icon: '/static/image/img_rw_xr.avif', limit: '仅限：电子-全部游戏', coinAmount: '50.00', lightning: 15, current: 0, target: 50000, progressPercent: 0, btnText: '前往' },
          { name: '累计投注≥100,000', icon: '/static/image/img_rw_xr.avif', limit: '仅限：电子-全部游戏', coinAmount: '50.00', lightning: 15, current: 0, target: 100000, progressPercent: 0, btnText: '前往' },
          { name: '累计投注≥300,000', icon: '/static/image/img_rw_xr.avif', limit: '仅限：电子-全部游戏', coinAmount: '100.00', lightning: 15, current: 0, target: 300000, progressPercent: 0, btnText: '前往' },
          { name: '累计投注≥500,000', icon: '/static/image/img_rw_xr.avif', limit: '仅限：电子-全部游戏', coinAmount: '200.00', lightning: 20, current: 0, target: 500000, progressPercent: 0, btnText: '前往' },
          { name: '累计投注≥1,000,000', icon: '/static/image/img_rw_xr.avif', limit: '仅限：电子-全部游戏', coinAmount: '500.00', lightning: 20, current: 0, target: 1000000, progressPercent: 0, btnText: '前往' },
          { name: '累计投注≥3,000,000', icon: '/static/image/img_rw_xr.avif', limit: '仅限：电子-全部游戏', coinAmount: '1,000.00', lightning: 30, current: 0, target: 3000000, progressPercent: 0, btnText: '前往' },
          { name: '累计投注≥5,000,000', icon: '/static/image/img_rw_xr.avif', limit: '仅限：电子-全部游戏', coinAmount: '3,000.00', lightning: 30, current: 0, target: 5000000, progressPercent: 0, btnText: '前往' },
        ];
        that.taskRules = [
          '1. 适用对象：所有平台注册用户',
          '2. 任务与奖励：完成以上任务可获得对应奖励，完成任务越多，收获越多',
          '3. 重置时间：每日任务只统计当天的数据，任务进度将于UTC+08:00的00:00自动更新并重置',
          '4. 领取条件：需要完成如下任务才可领取：设置真实姓名、完成首次充值',
          '5. 奖励发放：完成任务后，需在指定时间内手动领取，仅限Android_APP、iOS_APP',
          '6. 奖励有效期：所有类型的奖励均有有效期，请在规定时间内领取或者使用，逾期作废',
          '7. 投注说明：赠送的奖金需1倍流水（即稽核或有效投注）才能提现，投注仅限：',
          '棋牌-全部游戏，',
          '捕鱼-全部游戏，',
          '电子-全部游戏',
          '条款及细则',
          '1.每位玩家只能使用一个账号，不可使用多账号，开设多个或欺诈账户的玩家将被取消活动资格，剩余金额可能会被没收且账户将被冻结',
          '2.本站保留自行决定修改、变更、终止、取消、拒绝此优惠活动的权利',
          '3.参与活动的玩家必须接受并遵守本活动的条款，并且申请此优惠，即代表同意该活动规则及对应条款',
          '4.为避免文字理解歧义，本站保留本活动最终解释权',
        ];
      } else {
        that.taskList = [];
        that.taskRules = [];
      }
    },
    handleRefresh() {
      this.loadTaskList();
    },
    startCountdown() {
      // 计算到明天0点的剩余时间
      const updateCountdown = () => {
        const now = new Date();
        const tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);
        const diff = tomorrow - now;

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        this.countdownHours = String(hours).padStart(2, '0');
        this.countdownMinutes = String(minutes).padStart(2, '0');
        this.countdownSeconds = String(seconds).padStart(2, '0');
      };

      updateCountdown();
      this.countdownTimer = setInterval(updateCountdown, 1000);
    },
    goToRecord() {
      this.$router.push({ path: '/activity', query: { tab: '7' } }).catch(err => {
        if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled') {
          console.error(err);
        }
      });
    },
    handleTaskAction(item) {
      this.$parent.showTost(1, '功能开发中');
    },
  },
  watch: {
    activeTab() {
      this.loadTaskList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/common.css';

.task-page {
  min-height: 80vh;
  margin-top: 44px;
  padding: 0 0.2rem 1rem;

  .activity-box {
    background: #292A2C;
    border-radius: 0.12rem;
    padding: 0.15rem 0.2rem;
    margin-top: 0.15rem;
    margin-bottom: 0.15rem;

    .activity-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.1rem 0 0.15rem;

      .activity-left {
        display: flex;
        align-items: center;
        gap: 0.08rem;

        .lightning-icon-wrap {
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        .activity-value {
          font-size: 0.35rem;
          font-weight: bold;
          color: #3CC82F;
        }
      }

      .activity-detail {
        font-size: 0.3rem;
        color: #DFB372;
      }
    }

    .treasure-progress {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.1rem 0 0.15rem;

      .treasure-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        .treasure-icon-wrap {
          position: relative;
          width: 1.5rem;
          height: 1.5rem;
          display: flex;
          align-items: center;
          justify-content: center;

          .treasure-icon {
            width: 1.5rem;
            height: 1.5rem;
          }

          .treasure-num {
            position: absolute;
            bottom: 0.3rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.35rem;
            color: #fff;
            font-weight: bold;
          }
        }

        .treasure-label {
          font-size: 0.3rem;
          color: #888;
          margin-top: 0.08rem;
          display: flex;
          align-items: center;
          gap: 0.04rem;

          svg {
            flex-shrink: 0;
          }
        }
      }

      .treasure-arrow {
        display: flex;
        align-items: center;
        padding: 0 0.05rem;

        svg {
          width: 1.2rem;
          height: 0.3rem;
        }
      }
    }
  }

  .task-tabs {
    display: flex;
    align-items: center;
    gap: 0.15rem;
    padding: 0.15rem 0;
    flex-wrap: wrap;

    .task-tab {
      padding: 0.12rem 0.25rem;
      border-radius: 0.3rem;
      font-size: 0.3rem;
      color: #888;
      background: #292A2C;
      border: 1px solid #3B3C3D;

      &.active {
        color: #333;
        background: linear-gradient(90deg, #f3ca8e 0%, #dfb372 100%);
        border-color: #DFB372;
        font-weight: 600;
      }
    }

    .task-refresh {
      display: flex;
      align-items: center;
      gap: 0.06rem;
      font-size: 0.3rem;
      color: #DFB372;
      margin-left: auto;
    }
  }

  .newbie-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.15rem 0;
    margin-bottom: 0.1rem;

    .newbie-left {
      display: flex;
      align-items: center;
      gap: 0.08rem;

      .newbie-icon {
        width: 0.6rem;
        height: 0.6rem;
      }

      .newbie-badge {
        font-size: 0.22rem;
        color: #fff;
        background: #3CC82F;
        padding: 0.02rem 0.1rem;
        border-radius: 0.06rem;
        font-weight: bold;
      }
    }

    .newbie-right {
      cursor: pointer;
    }
  }

  .daily-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.15rem 0;
    margin-bottom: 0.1rem;

    .daily-left {
      display: flex;
      align-items: center;
      gap: 0.15rem;

      .daily-icon {
        width: 0.8rem;
        height: 0.8rem;
      }

      .daily-countdown {
        display: flex;
        align-items: center;
        gap: 0.05rem;

        .countdown-num {
          font-size: 0.35rem;
          color: #fff;
          background: #DFB372;
          padding: 0.05rem 0.1rem;
          border-radius: 0.06rem;
          font-weight: bold;
          min-width: 0.4rem;
          text-align: center;
        }

        .countdown-sep {
          font-size: 0.35rem;
          color: #fff;
          font-weight: bold;
        }

        .countdown-text {
          font-size: 0.3rem;
          color: #fff;
          margin-left: 0.1rem;
        }
      }
    }

    .daily-right {
      cursor: pointer;
    }
  }

  .task-list {
    .task-item {
      background: #292A2C;
      border-radius: 0.12rem;
      margin-bottom: 0.25rem;
      overflow: hidden;

      .task-name-bar {
        display: flex;
        align-items: center;
        gap: 0.1rem;
        padding: 0.15rem 0.2rem;
        background: #3D3A2E;

        &.no-icon {
          padding-left: 0.2rem;
        }

        .task-icon-wrap {
          display: flex;
          align-items: center;
          position: relative;
          flex-shrink: 0;
        }

        .task-icon {
          width: 0.4rem;
          height: 0.4rem;
          flex-shrink: 0;
        }

        .task-name {
          font-size: 0.35rem;
          color: #fff;
          font-weight: bold;
        }

        .task-limit {
          font-size: 0.3rem;
          color: #888;
          margin-left: 0.1rem;
        }
      }

      .task-body {
        display: flex;
        align-items: center;
        padding: 0.2rem 0.15rem;
        gap: 0.15rem;

        .reward-coin,
        .reward-lightning {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.04rem;

          .coin-icon-circle {
            width: 0.5rem;
            height: 0.5rem;
            border-radius: 50%;
            background: #ffaa09;
            display: flex;
            align-items: center;
            justify-content: center;

            .icon-coin {
              font-size: 0.35rem;
              color: #000;
              font-weight: bold;
            }
          }

          .reward-amount {
            font-size: 0.3rem;
            color: #DFB372;
          }

          .lightning-amount {
            font-size: 0.3rem;
            color: #3CC82F;
          }
        }

        .task-progress {
          flex: 1;
          display: flex;
          align-items: center;
          gap: 0.1rem;

          .progress-bar {
            flex: 1;
            height: 0.2rem;
            background: #3B3C3D;
            border-radius: 0.1rem;
            overflow: hidden;

            .progress-fill {
              height: 100%;
              background: linear-gradient(90deg, #f3ca8e 0%, #dfb372 100%);
              border-radius: 0.1rem;
            }
          }

          .progress-text {
            font-size: 0.3rem;
            color: #888;
            white-space: nowrap;
          }
        }

        .task-btn {
          padding: 0.12rem 0;
          border-radius: 0.3rem;
          font-size: 0.3rem;
          background: linear-gradient(90deg, #f3ca8e 0%, #dfb372 100%);
          color: #333;
          white-space: nowrap;
          text-align: center;
          flex: 0 0 25%;
          min-width: 0;
          margin-left: auto;
        }

        // 每日任务：所有子元素等宽
        &.daily-layout {
          > div {
            flex: 1;
          }
          .task-btn {
            margin-left: 0;
          }
        }

        // 新人福利：奖励区域往右移
        &:not(.daily-layout) {
          .reward-coin,
          .reward-lightning {
            margin-left: 0.5rem;
          }
        }
      }
    }
  }

  .task-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 0;

    .empty-icon-wrap {
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.05);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.4rem;

      .empty-icon {
        width: 2.5rem;
        height: 2.5rem;
        opacity: 0.5;
      }
    }

    .empty-text {
      font-size: 0.3rem;
      color: #666;
    }
  }

  .task-rules {
    padding: 0.2rem 0.15rem;
    background: #292A2C;
    border-radius: 0.12rem;
    margin-top: 0.15rem;

    .rule-item {
      font-size: 0.3rem;
      color: #888;
      line-height: 1.6;
      margin-bottom: 0.1rem;

      &.rule-title {
        color: #fff;
        font-weight: bold;
        margin-top: 0.1rem;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .detail-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 210;
  }

  .detail-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 85%;
    max-height: 80vh;
    background: #292A2C;
    border-radius: 0.2rem;
    z-index: 220;
    padding: 0.3rem;
    overflow-y: auto;

    .detail-header {
      text-align: center;
      font-size: 0.35rem;
      color: #fff;
      margin-bottom: 0.2rem;
    }

    .detail-tabs {
      display: flex;
      gap: 0.3rem;
      margin-bottom: 0.2rem;
      border-bottom: 1px solid #3B3C3D;
      padding-bottom: 0.15rem;

      .detail-tab {
        font-size: 0.3rem;
        color: #888;
        padding-bottom: 0.1rem;
        position: relative;

        &.active {
          color: #DFB372;

          &::after {
            content: '';
            position: absolute;
            bottom: -0.16rem;
            left: 0;
            right: 0;
            height: 2px;
            background: #DFB372;
          }
        }
      }
    }

    .detail-filter-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.2rem;

      .detail-filter-item {
        display: flex;
        align-items: center;
        gap: 0.06rem;
        padding: 0.1rem 0.2rem;
        background: #1E1F24;
        border: 1px solid #3B3C3D;
        border-radius: 0.3rem;
        font-size: 0.3rem;
        color: #fff;
        position: relative;

        .detail-filter-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          margin-top: 0.08rem;
          background: #292A2C;
          border: 1px solid #3B3C3D;
          border-radius: 0.12rem;
          overflow: hidden;
          z-index: 10;
          min-width: 1.5rem;

          .detail-filter-option {
            padding: 0.12rem 0.2rem;
            text-align: center;
            font-size: 0.3rem;
            color: #888;

            &.active {
              color: #DFB372;
              background: rgba(223, 179, 114, 0.1);
            }
          }
        }
      }

      .detail-activity {
        display: flex;
        align-items: center;
        gap: 0.06rem;
        font-size: 0.3rem;
        color: #888;

        svg {
          width: 0.32rem;
          height: 0.32rem;
        }

        span {
          color: #3CC82F;
          font-size: 0.3rem;
        }
      }
    }

    .detail-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 2rem 0;

      .empty-icon-wrap {
        width: 3rem;
        height: 3rem;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.05);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.3rem;

        .empty-icon {
          width: 2rem;
          height: 2rem;
          opacity: 0.5;
        }
      }

      .empty-text {
        font-size: 0.28rem;
        color: #666;

        .empty-link {
          color: #DFB372;
        }
      }
    }

    .detail-close {
      display: flex;
      justify-content: center;
      margin-top: 0.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/component/task.vue